import { cn } from '@/lib/utils';

/**
 * Variantes oficiais da marca, todas com fundo transparente.
 *
 * - `horizontal` / `compact`: wordmark navy + laranja — só em superfície clara.
 * - `*OnDark`: wordmark branco + laranja — só em navy/escuro.
 * - `compact*`: sem a assinatura (ilegível abaixo de ~60px).
 * - `mark*`: só o símbolo, para espaços estreitos.
 */
const SRC = {
  horizontal: '/logo-horizontal.png',
  horizontalOnDark: '/logo-horizontal-branco.png',
  compact: '/logo-horizontal-compacta.png',
  compactOnDark: '/logo-horizontal-compacta-branco.png',
  mark: '/logo-simbolo.png',
  markOnDark: '/logo-simbolo-branco.png',
  vertical: '/logo-vertical.png',
  verticalOnDark: '/logo-vertical-branco.png',
} as const;

export type BrandLogoVariant = keyof typeof SRC;

interface BrandLogoProps {
  variant: BrandLogoVariant;
  className?: string;
  alt?: string;
  decorative?: boolean;
}

export function BrandLogo({
  variant,
  className,
  alt = 'AgilizaOS',
  decorative = false,
}: BrandLogoProps) {
  return (
    <img
      src={SRC[variant]}
      alt={decorative ? '' : alt}
      aria-hidden={decorative || undefined}
      className={cn('w-auto object-contain object-left', className)}
    />
  );
}
